module.exports = __webpack_public_path__ + "static/media/ImporterFeature5.42f55dfa.svg";